import Store from 'src/store';
export default function getter(entity, getterName) {
    const storeGetters = Store.getters;
    const result = storeGetters[entity + '/' + getterName];
    return result;
}
